import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { Divider } from '@/design-system/components/Divider';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { Icon } from '@/design-system/components/icons/Icon';
import { ModalHeader } from '@/design-system/components/modal';
import { TextBody } from '@/design-system/components/typography';
import { pointer } from 'd3';
import { SxProp, View, Image } from 'dripsy';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ReplaceCardProps {
  onClose: () => void;
  onStep: (step: string) => void;
}

export const ReplaceCardWebOneScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose, onStep } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, flexContainer, address } = sxStyles;

  return (
    <View>
      <View sx={topHeader}>
        <ModalHeader title="Replace Card" closeModal={onClose} />
      </View>
      <View sx={body}>
        <TextBody sx={textMb} semiBold>
          Select a reason to replace the card.
        </TextBody>
        <View sx={{ gap: 10 }}>
          <TextBody sx={itemStyle} onPress={() => onStep('two')}>
            <TextBody semiBold>Self Pickup</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
          <TextBody sx={itemStyle} onPress={() => onStep('two')}>
            <View sx={flexContainer}>
              <TextBody semiBold>Mail to Address</TextBody>
              <TextBody sx={address}>
                Block 1, 1/F, Flat A, Super Building,
                <br />1 Sample Road, Jordan, Hong Kong
              </TextBody>
            </View>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
        </View>
        <View sx={{ flex: 1, display: 'grid', gap: '$3', mt: '$10' }}>
          <UniButton variant={ButtonVariant.outline1} sx={{ width: '100%', height: 44 }} label="Back" onPress={() => onStep('zero')} />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    height: 70,
    justifyContent: 'center'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28
  },
  textMb: {
    marginBottom: 20
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 20,
    py: 30,
    cursor: 'pointer',
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowRadius: 10,
    borderRadius: 10
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  },
  flexContainer: {
    gap: 4
  },
  address: {
    color: '$textSecondary',
    fontSize: 13
  }
};
